import { ArrowRight, Filter, Search, Calendar, List, Grid, } from "react-feather";
import { DatePicker, DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import styles from "../incomeList.module.css";
import dayjs from "dayjs";
import FilterAutocomplete from "../../../../../../components/FilterAutocomplete";

const PAYMENT_STATUS_OPTIONS = [
  { value: 1, label: "Completed" },
  { value: 0, label: "Pending" },
  { value: 2, label: "Failed" },
];

const ListFilters = ({ setFilterData, setFilterOpen, filterOpen, filterData, selectProperty, propertyList, apartmentList, handleView, setCurrentFilterValue, incomeCategories }) => {

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input
          type="text"
          placeholder="Search"
          onChange={(e) => {
            setFilterData((prev) => {
              return { ...prev, searchKey: e.target.value };
            });

            setCurrentFilterValue("search");
          }}
        />
      </div>
      <div className={`${styles.ListGridBUCard}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("grid")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters
          <span onClick={(e) => setFilterOpen(false)}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Property"
            options={propertyList}
            value={filterData?.property}
            onChange={(value) => {
              // The apartment filter belongs to the previous property, so clear it
              setFilterData((prev) => ({ ...prev, property: value, apartment: "" }));
              selectProperty(value);
              setCurrentFilterValue("property");
            }}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Apartment"
            options={apartmentList}
            value={filterData?.apartment}
            noOptionsText={filterData?.property !== "" ? "No apartments" : "Select Property First"}
            onChange={(value) => {
              setFilterData((prev) => ({ ...prev, apartment: value }));
              setCurrentFilterValue("apartment");
            }}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Category"
            options={(incomeCategories || []).map((i) => ({ value: i.id, label: i.title }))}
            value={filterData?.category}
            onChange={(value) => {
              setFilterData((prev) => ({ ...prev, category: value }));
              setCurrentFilterValue("category");
            }}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Payment Status"
            options={PAYMENT_STATUS_OPTIONS}
            value={filterData?.payment_status}
            onChange={(value) => {
              setFilterData((prev) => ({ ...prev, payment_status: value }));
              setCurrentFilterValue("payment_status");
            }}
          />
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              onChange={(date) => {
                setFilterData((prev) => {
                  return { ...prev, last_payment_date: date };
                });
                setCurrentFilterValue("last_payment_date");
              }}
            />
          </div>
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DatePicker
              oneTap
              format="MMM yyyy"
              placeholder={"Monthly Rentroll"}
              placement={"bottomEnd"}
              disabledDate={(date) => date > new Date()}
              caretAs={Calendar}
              onChange={(date) => {
                if (date) {
                  setFilterData((prev) => {
                    return { ...prev, rent_month_text: dayjs(date).format('MMM YYYY'), rent_month: dayjs(date).format('YYYY-MM'), category: 1 };
                  });
                } else {
                  setFilterData((prev) => {
                    return { ...prev, rent_month_text: '', rent_month: '', category: '' };
                  });

                }
                setCurrentFilterValue("monthly_rentroll");
              }}
            />
          </div>
        </div>
      </div>
      <div className={`${styles.ListGridBUCard}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("grid")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>
      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
        <Filter />
      </Link>
    </div>
  </div>);
};

export default ListFilters;